import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/problem/:publicID',
    name: 'Problem',
    component: () => import(/* webpackChunkName: "problem" */ '../views/Problem.vue')
  },
  {
    path: '/edit/:publicID?',
    name: 'Edit',
    component: () => import(/* webpackChunkName: "about" */ '../views/Edit.vue')
  },
  {
    path: '/system',
    name: 'SystemConfig',
    component: () => import(/* webpackChunkName: "system" */ '../views/SystemConfig.vue')
  },
  // {
  //   path: '/admin',
  //   name: 'Admin',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue')
  // },
  // {
  //   path: '/search',
  //   name: 'Search',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Search.vue')
  // }
]

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router